import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useState } from 'react';


const KinoTheater: React.FC = () => {

    const [isVideoLoaded, setIsVideoLoaded] = useState(false);
  
    const handleFacadeClick = () => {
      setIsVideoLoaded(true);
    };

  return (


  <div className="breadcrumbs">

  <Helmet>
    <title>KinoTheater LUZIFER - Сергей Мавроди: Экранизация и Анимация</title>
    <meta
      name="description"
      content="KinoTheater LUZIFER: экранизация 'Сын Люцифера', анимация стихов и проект 'ZОМБИ' на официальном сайте Сергея Мавроди."
    />
    <meta name="keywords" content="Сергей Мавроди, KinoTheater, Сын Люцифера, стихи, анимация, ZОМБИ, кино" />
    <meta name="author" content="Сергей Мавроди" />
    <meta property="og:title" content="KinoTheater LUZIFER - Сергей Мавроди" />
    <meta
      property="og:description"
      content="Раздел KinoTheater LUZIFER: экранизация 'Сын Люцифера', анимация стихов и проект 'ZОМБИ'."
    />
    <meta property="og:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:url" content="https://sergey-mavrodi.com/kinotheater" />
    <meta property="og:type" content="website" />
    <meta property="og:locale" content="ru_RU" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="KinoTheater LUZIFER - Сергей Мавроди" />
    <meta
      name="twitter:description"
      content="Раздел KinoTheater LUZIFER: экранизация 'Сын Люцифера', анимация стихов и проект 'ZОМБИ'."
    />
    <meta name="twitter:image" content="https://sergey-mavrodi.com/images/portrait.webp" />
    <link rel="canonical" href="https://sergey-mavrodi.com/kinotheater" />
    <script type="application/ld+json">
      {JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        'name': 'KinoTheater LUZIFER',
        'description': 'Раздел KinoTheater LUZIFER на сайте Сергея Мавроди: экранизация "Сын Люцифера", анимация стихов и проект "ZОМБИ".',
        'url': 'https://sergey-mavrodi.com/kinotheater',
        'image': 'https://sergey-mavrodi.com/images/portrait.webp',
        'publisher': {
          '@type': 'Organization',
          'name': 'Сергей Мавроди',
        },
        'breadcrumb': {
          '@type': 'BreadcrumbList',
          'itemListElement': [
            {
              '@type': 'ListItem',
              'position': 1,
              'name': 'Главная',
              'item': 'https://sergey-mavrodi.com/',
            },
            {
              '@type': 'ListItem',
              'position': 2,
              'name': 'KinoTheater LUZIFER',
              'item': 'https://sergey-mavrodi.com/kinotheater',
            },
          ],
        },
      })}
    </script>
  </Helmet>

    <div className="breadcrumb">
      <div id="breadcrumb">
      <Link to="/">Главная страница</Link> → KinoTheater LUZIFER
      </div>
    </div>
    <div className="content">
      <div className="content_white_cloud">
        
        <div className="cwc_mid">
          <div className="content">
            <h2>KinoTheater LUZIFER</h2>
           
           
            <div style={{ backgroundColor: 'rgb(220, 220, 220)', textAlign: 'center' }}>
            <p>&nbsp;</p>
            <div style={{ backgroundColor: 'white', marginLeft: '30px', marginRight: '30px' }}>
            <div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>

              <div style={{maxWidth: '531px', margin: '0 auto'}}>
                {!isVideoLoaded ? (
                  <div style={{borderRadius: '0'}}
                    onClick={handleFacadeClick}
                          role="button"
                          tabIndex={0}
                          onKeyDown={(e) => e.key === 'Enter' && handleFacadeClick()}
                    className="video-preview"
                  >
                    <img 
                      src="/video/P13.avif"
                      alt="Приглашаются желающие поучаствовать"
                      className="video-thumbnail"
                      width="320"
                      height="240"
                    />
                    <svg
                      className="play-button"
                      fill="violet"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                ) : (
                  <video style={{borderRadius: '0'}}
                    src="/video/P13.mp4"
                    className="video-player"
                    controls
                    autoPlay
                    playsInline
                  />
                )}
              </div>

            <p style={{ margin: '0 0 0 0' }}>&nbsp;</p> 

<div style={{ backgroundColor: 'rgb(243, 243, 243)', marginLeft: '20px', marginRight: '20px' }}>

<strong><Link to="/kinotheater/sohnluzifers" className="yellow-underline" style={{ fontSize: '33px' }}>Сын Люцифера (экранизация)</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/kinotheater/gedichte" className="yellow-underline" style={{ fontSize: '33px' }}>Стихи (анимация)</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><Link to="/kinotheater/zombi" className="yellow-underline" style={{ fontSize: '33px' }}>ZОМБИ (сериал)</Link></strong>

<div style={{ backgroundColor: 'rgb(255, 255, 255)', }}>&nbsp;</div>
<strong><a href="https://kinotheater-luzifer.com"
                  style={{fontSize: '33px',
                    textDecorationColor: 'rgb(255, 205, 0)',
                    textUnderlineOffset: '5px',
                    fontFamily: '"Times New Roman", "Times CY", "Nimbus Roman No9 L", serif'}}
                  aria-label="kinotheater-luzifer.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >kinotheater-luzifer.com
                </a></strong>

</div>

<p>&nbsp;</p>
</div>
<p>&nbsp;</p>
</div> 
          </div>
        </div>
        
      </div>
    </div>
  </div>
);
};

export default KinoTheater;
